import badwords from './offensive-words.data';

interface UserField {
	name: string;
	value: string;
}

export const unacceptableInputs = (inputs: UserField[]) => {
	const inputsToTest = inputs.map((input) => ({ ...input, value: input.value.toLocaleLowerCase() }));
	const unacceptableFieldNames: string[] = [];
	inputsToTest.forEach((input) => {
		if (badwords.includes(input.value)) {
			unacceptableFieldNames.push(input.name);
		}
	});
	return unacceptableFieldNames;
};
